import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import block from 'bem-cn'

import { MODAL_ROUTE_PATH } from 'router/modalRoutes'

import { mediaSize } from 'shared/style/var'
import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import { selectLocaleDict } from 'features/locale/selectors'

import { choiceofSport } from './data'
import { ChoiceOfSport } from './types'

import './SportModal.scss'

const b = block('sport-modal')

const SportModal: React.FC<{ path?: string }> = ({ path = '' }) => {
  const params = getRouteParamsByStrings<{ type: ChoiceOfSport }>(MODAL_ROUTE_PATH.CHOOSE_SPORT, path)
  const isMobileOrTablet = useMediaQuery({ maxWidth: mediaSize.tablet })

  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const items = useMemo(
    () =>
      choiceofSport[params?.type as ChoiceOfSport].map(item => (
        <Link
          key={item.link}
          className={b('item')}
          to={isMobileOrTablet && item.mobileLink ? item.mobileLink : item.link}>
          <div className={b('item-left')}>
            {item.icon && <img src={item.icon} alt="" className={b('item-icon')} />}
            <div className={b('text')}>{locale[item.text]}</div>
          </div>
        </Link>
      )),
    [isMobileOrTablet, locale, params?.type],
  )
  return (
    <div className={b()}>
      <div className={b('items')}>{items}</div>
    </div>
  )
}

export default SportModal
